import { EmptyState, EmptyStateIllustrationImage } from 'components/EmptyState'
import { observer } from 'mobx-react'
import React from 'react'
import OCRScopeWork from '../../../../../../../../wunder/OCRScopeWork'

interface OCRScopeJobUnderReviewProps {
  vm: OCRScopeWork
}
export default observer(function OCRScopeJobUnderReview({
  vm,
}: OCRScopeJobUnderReviewProps) {
  return (
    <EmptyState
      image={
        <EmptyStateIllustrationImage
          src={require('assets/images/img_get-started.svg')}
        />
      }
      title={'OCR scoping requires review'}
      subtitle={
        <span>
          There seems to be an issue scoping <b>{vm.fileName}</b> at the moment.
          Our team is aware of the problem and will update the job on your
          behalf.
        </span>
      }
      animate
      small
    ></EmptyState>
  )
})
